import React, { Component } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { safeDeepGetWithType, safeDeepGet } from 'iotera-base/json';
import RefreshIcon from '@material-ui/icons/RefreshOutlined';
import AddIcon from '@material-ui/icons/AddOutlined';
import EditIcon from '@material-ui/icons/EditOutlined';
import SaveIcon from '@material-ui/icons/SaveOutlined';
import Check from '@material-ui/icons/Check';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';
import IconButton from '@material-ui/core/IconButton';
import { S } from '../../../routes/routes';
import { titleCase, subTitleCase } from '../formatter';
import { isFunction } from 'iotera-base/object';
import { ioteraConfirmAlert } from '../react/react-confirm-alert';

import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepConnector from '@material-ui/core/StepConnector'
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

export class SubViewHeaderDashboard extends Component {
    constructor(props) {
        super(props);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleRefresh = this.handleRefresh.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
        this.handleSave = this.handleSave.bind(this);

    }

    handleAdd = (_this) => (e) => {
        let handleAdd = safeDeepGet(_this, ['props', 'handleAdd']);
        if (isFunction(handleAdd)) {
            handleAdd();
        }
    }

    handleRefresh = (_this) => (e) => {
        let handleRefresh = safeDeepGet(_this, ['props', 'handleRefresh']);
        if (isFunction(handleRefresh)) {
            handleRefresh();
        }
    }

    handleAdd = (_this) => (e) => {
        let handleAdd = safeDeepGet(_this, ['props', 'handleAdd']);
        if (isFunction(handleAdd)) {
            ioteraConfirmAlert(
                'Konfirmasi',
                'Ingin tambah manual atau dengan bantuan editor?',
                'Editor',
                () => handleAdd(true),
                'Manual',
                () => handleAdd(false),
            )
        }
    }

    handleEdit = (_this) => (e) => {
        let handleEdit = safeDeepGet(_this, ['props', 'handleEdit']);
        if (isFunction(handleEdit)) {
            handleEdit();
        }
    }

    handleSave = (_this) => (e) => {
        let saveLayout = safeDeepGet(_this, ['props', 'saveLayout']);
        if (isFunction(saveLayout)) {
            saveLayout();
        }
    }


    render() {
        let title = safeDeepGetWithType(this, ['props', 'title'], '');
        title = titleCase(title)
        let subTitle = safeDeepGetWithType(this, ['props', 'subTitle'], '');
        subTitle = subTitleCase(subTitle)
        let color = safeDeepGetWithType(this, ['props', 'color'], '#fff');
        let hasRefresh = safeDeepGetWithType(this, ['props', 'hasRefresh'], false);

        let custom_col = hasRefresh ? "col-md-6" : "col-md-12";

        let visibility = 'hidden';

        if (subTitle !== '') {
            visibility = 'visible'
        }
        const _this = this;

        return (
            <AppBar position="sticky" color="default">
                <Toolbar>
                    <Typography variant="h6" color="inherit" style={{ minWidth: '100%' }}>
                        <div className='row centeringItemVertical' style={{ paddingLeft: 12 }}>
                            <div className={custom_col}>
                                <div >
                                    <div style={{ color: '#fff' }} >{title}</div>
                                    <div style={{ fontSize: 'small', fontWeight: 300, visibility, color, fontStyle: 'italic' }}>{subTitle}</div>
                                </div>
                            </div>
                            {hasRefresh ?
                                <div className='col-md-6 centeringItemVertical button-right' >
                                    <span style={{ minWidth: '100%' }}>
                                        <Tooltip TransitionComponent={Zoom} title="Refresh" enterDelay={500} style={{ marginRight: 10 }}>
                                            <IconButton color="inherit" aria-label="Menu" onClick={this.handleRefresh(_this)}>
                                                <RefreshIcon size="24" />
                                            </IconButton>
                                        </Tooltip>
                                        {window.innerWidth >= 996 ?
                                            <Tooltip TransitionComponent={Zoom} title="Save" enterDelay={500} style={{ marginRight: 10 }}>
                                                <IconButton color="inherit" aria-label="Menu" onClick={this.handleSave(_this)}>
                                                    <SaveIcon size="24" />
                                                </IconButton>
                                            </Tooltip>
                                            : null}
                                        <Tooltip TransitionComponent={Zoom} title="Edit" enterDelay={500} style={{ marginRight: 10 }} >
                                            <IconButton color="inherit" aria-label="Menu" onClick={this.handleEdit(_this)}>
                                                <EditIcon size="24" />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip TransitionComponent={Zoom} title="Add" enterDelay={500} >
                                            <IconButton color="inherit" aria-label="Menu" onClick={this.handleAdd(_this)}>
                                                <AddIcon size="24" />
                                            </IconButton>
                                        </Tooltip>
                                    </span>
                                </div>
                                :
                                null}
                        </div>
                    </Typography>
                </Toolbar>
            </AppBar>
        );
    }

}

export class SubViewHeader extends Component {
    constructor(props) {
        super(props);
        this.handleRefresh = this.handleRefresh.bind(this);

    }

    handleRefresh = (_this) => (e) => {
        let path = safeDeepGetWithType(_this, ['props', 'path'], '');
        // TODO Refresh local
        _this.props.history.push('.' + S + 'empty')
        setTimeout(function () {
            _this.props.history.push('.' + S + path)
        }, 1)
    }


    render() {
        let title = safeDeepGetWithType(this, ['props', 'title'], '');
        title = titleCase(title)
        let subTitle = safeDeepGetWithType(this, ['props', 'subTitle'], '');
        let color = safeDeepGetWithType(this, ['props', 'color'], '#fff');
        let hasRefresh = safeDeepGetWithType(this, ['props', 'hasRefresh'], false);

        let custom_col = hasRefresh ? "col-md-6" : "col-md-12";

        let visibility = 'hidden';

        if (subTitle !== '') {
            visibility = 'visible'
        }
        const _this = this;

        return (
            <AppBar position="sticky" color="default">
                <Toolbar>
                    <Typography variant="h6" color="inherit" style={{ minWidth: '100%' }}>
                        <div className='row centeringItemVertical' style={{ paddingLeft: 12 }}>
                            <div className={custom_col}>
                                <div >
                                    <div style={{ color: '#fff' }} >{title}</div>
                                    <div style={{ fontSize: 'small', fontWeight: 300, visibility, color, fontStyle: 'italic' }}>{subTitle}</div>
                                </div>
                            </div>
                            {hasRefresh ?
                                <div className='col-md-6 centeringItemVertical button-right' >
                                    <div style={{ minWidth: '100%' }}>
                                        <Tooltip TransitionComponent={Zoom} title="Refresh" enterDelay={500}>
                                            <IconButton color="inherit" aria-label="Menu" onClick={this.handleRefresh(_this)}>
                                                <RefreshIcon size="24" />
                                            </IconButton>
                                        </Tooltip>
                                    </div>
                                </div>
                                :
                                null}
                        </div>
                    </Typography>
                </Toolbar>
            </AppBar>
        );
    }

}

export class SubViewHeaderWithTenantName extends Component {
    constructor(props) {
        super(props);
        this.handleRefresh = this.handleRefresh.bind(this);
    }

    handleRefresh = () => (e) => {
        let path = safeDeepGetWithType(this, ['props', 'path'], '');
        const _this = this;
        // TODO Refresh local
        _this.props.history.push('.' + S + 'empty')
        setTimeout(function () {
            _this.props.history.push('.' + S + path)
        }, 1)
    }

    render() {
        let title = safeDeepGetWithType(this, ['props', 'title'], '');
        let isKomatsu = safeDeepGetWithType(this, ['props', 'isKomatsu'], true);
        let hasRefresh = safeDeepGetWithType(this, ['props', 'hasRefresh'], false);
        let subTitle = safeDeepGetWithType(this, ['props', 'subTitle'], '');
        let color = safeDeepGetWithType(this, ['props', 'color'], '#fff'/* '#4D2C91' */);

        let visibility = 'hidden';

        if (subTitle !== '')
            visibility = 'visible'

        return (
            <AppBar position="sticky" color="default">
                <Toolbar>
                    <Typography variant="h6" color="inherit" style={{ minWidth: '100%' }}>
                        <div className='row' style={{ paddingLeft: 12 }}>
                            <div className='col-md-6 centeringItemVertical' >
                                <div >
                                    <div className='text-capitalize' style={{ color: '#fff' }} >{title}</div>
                                    <div style={{ fontSize: 'small', fontWeight: 300, visibility, color }}>{subTitle}</div>
                                </div>
                            </div>
                            {hasRefresh ?
                                <div className='col-md-6 centeringItemVertical button-right' >
                                    <div style={{ minWidth: '100%' }}>
                                        <Tooltip TransitionComponent={Zoom} title="Refresh" enterDelay={500}>
                                            <IconButton color="inherit" aria-label="Menu" onClick={this.handleRefresh()}>
                                                <RefreshIcon size="24" />
                                            </IconButton>
                                        </Tooltip>
                                    </div>
                                </div>
                                :
                                isKomatsu ?
                                    <div className='col-md-6 centeringItemVertical button-right' >
                                        <div style={{ minWidth: '100%' }}>
                                            <div style={{ color: '#fff' }} >KOMEEC</div>
                                            <div style={{ fontSize: 'small', fontWeight: 300, color }}>{'Komatsu Monitoring Energy & Environtment Control'}</div>
                                        </div>
                                    </div>
                                    :
                                    null
                            }
                        </div>

                    </Typography>
                </Toolbar>
            </AppBar>
        );
    }
}

const QontoConnector = withStyles({
    alternativeLabel: {
        top: 10,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)',
    },
    active: {
        '& $line': {
            borderColor: '#F5F6F7',
        },
        '& $text': {
            color: '#F5F6F7',
        },
        '& $label': {
            color: '#F5F6F7',
        }
    },
    completed: {
        '& $line': {
            borderColor: '#F5F6F7',
        },
    },
    line: {
        borderColor: '#979CA4',
        borderTopWidth: 3,
        borderRadius: 1,
    },
})(StepConnector);

const useQontoStepIconStyles = makeStyles({
    root: {
        color: '#979CA4',

        display: 'flex',
        height: 22,
        alignItems: 'center',
    },
    active: {
        color: '#F5F6F7',
    },
    circle: {
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: 'currentColor',
    },
    completed: {
        color: '#F5F6F7',
        zIndex: 1,
        fontSize: 18,
    },
});


function QontoStepIcon(props) {
    const classes = useQontoStepIconStyles();
    const { active, completed } = props;
    return (
        <div
            className={clsx(classes.root, {
                [classes.active]: active,
            })}
        >
            {completed ? <Check className={classes.completed} /> : <div className={classes.circle} />}
        </div>
    );
}

QontoStepIcon.propTypes = {
    active: PropTypes.bool,
    completed: PropTypes.bool,
};


export class SubViewHeaderStep extends Component {
    render() {
        let title = safeDeepGetWithType(this, ['props', 'title'], '');
        let subTitle = safeDeepGetWithType(this, ['props', 'subTitle'], '');
        let color = safeDeepGetWithType(this, ['props', 'color'], '#fff');
        let activeStep = safeDeepGetWithType(this, ['props', 'activeStep'], 0);
        let steps = safeDeepGetWithType(this, ['props', 'steps'], []);

        let finalSteps = [];

        for (let i = 0; i < steps.length; i++) {
            finalSteps.push(
                { 'title': steps[i] }
            )
        }

        let visibility = 'hidden';

        if (subTitle !== '')
            visibility = 'visible'

        return (
            <AppBar position="sticky" color="default">
                <Toolbar>
                    <Typography variant="h6" color="inherit" style={{ minWidth: '100%' }}>
                        <div className='row centeringItemVertical' style={{ paddingLeft: 12 }}>
                            <div className='col-md-6'>
                                <div>
                                    <div style={{ color: '#fff' }} >{title}</div>
                                    <div style={{ fontSize: 'small', fontWeight: 300, visibility, color }}>{subTitle}</div>
                                </div>
                            </div>
                            <div className="col-md-6"  >
                                <Stepper alternativeLabel activeStep={activeStep} connector={<QontoConnector />} style={{ backgroundColor: '#7E57C2' }}>
                                    {steps.map(label => (
                                        <Step key={label}>
                                            <StepLabel StepIconComponent={QontoStepIcon}>{label}</StepLabel>
                                        </Step>
                                    ))}
                                </Stepper>
                            </div>
                        </div>

                    </Typography>
                </Toolbar>
            </AppBar>
        );
    }
}